import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/styling';
import { type ElementType } from 'react';

type Props = {
  appLink: string;
  icon: ElementType;
  label?: string;
  className?: string;
  iconClassName?: string;
};

function AppLinkButton({
  appLink,
  icon,
  label,
  iconClassName,
  className,
}: Props) {
  const Icon = icon;
  return (
    <Button
      variant={'secondary'}
      asChild
      className={cn(
        'w-[16rem] md:w-[20rem] rounded-full h-[5.6rem]',
        className
      )}>
      <a
        href={appLink}
        target="_blank"
        rel="noopener noreferrer"
        className="gap-[0.9rem]">
        <Icon className={cn('size-48 text-primary', iconClassName)} />
        {label && (
          <span className="text-primary text-[17px] font-[500]">
            {label}
          </span>
        )}
      </a>
    </Button>
  );
}

export { AppLinkButton };
